import React, { useState, useEffect } from "react";
import "./style.css";
import Header from "../../../componente/header";
import Paginacao from "../../../componente/paginacao";
import Impressora from "../../../assets/Impressora.png";
import api from "../../../services/api";
import LoadingScreen from "../../../componente/aguarde";
import ModalCobranca from "react-modal";
import ModalValorVendido from "react-modal";
import PopUpHis from "../../../componente/popup";
import PopUpMotivoExclusao from "../../../componente/popup";
import { podeImprimir } from "../../../componente/permissoes";

const API_URL = "v1/relatorio";
const AUTOCOMPLETE_URL = "v1/relatorio/filtro";

const RelVendaPorEquipe = () => {
  const [abusca, setabusca] = useState("");
  const [valor, setValor] = useState(0);
  const [offset, setOffset] = useState(0);
  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [edtcidade, setedtcidade] = useState("0");
  const [edtbairro, setedtbairro] = useState("");
  const [lista, setlista] = useState([]);
  const [listaequipe, setlistaequipe] = useState([]);
  const [listacidade, setlistacidade] = useState([]);
  const [listabairro, setlistabairro] = useState([]);
  const [edtuf, setedtuf] = useState("");
  const [qtdetotalpag, setqtdetotalpag] = useState(0);
  const [loading, setLoading] = useState(false);
  const [inputValue2, setInputValue2] = useState("");
  const [inputValue3, setInputValue3] = useState("");
  const [inputValue4, setInputValue4] = useState("");
  const [tipoPano1, setTipoPano1] = useState("T");
  const [tipoCliente, setTipoCliente] = useState("T");
  const [status, setStatus] = useState("T");
  const [ativo, setAtivo] = useState("T");
  const [ordValorVenda, setOrdValorVenda] = useState(true);

  const [qtdevendas, setqtdevendas] = useState(0);
  const [totalvalorpano, settotalvalorpano] = useState(0);
  const [totalvalorvendido, settotalvalorvendido] = useState(0);
  const [totalvalorempresa, settotalvalorempresa] = useState(0);
  const [qtdetotalpago, setqtdetotalpago] = useState(0);
  const [totalvalorpago, settotalvalorpago] = useState(0);
  const [qtdetotalaberto, setqtdetotalaberto] = useState(0);
  const [totalvaloraberto, settotalvaloraberto] = useState(0);
  const [qtdetotalnaovisto, setqtdetotalnaovisto] = useState(0);
  const [totalvalornaovisto, settotalvalornaovisto] = useState(0);
  const [qtdetotaldevolvido, setqtdetotaldevolvido] = useState(0);
  const [totalvalordevolvido, settotalvalordevolvido] = useState(0);
  const [qtdetotalporconta, setqtdetotalporconta] = useState(0);
  const [totalvalorporconta, settotalvalorporconta] = useState(0);
  const [qtdetotalobjeto, setqtdetotalobjeto] = useState(0);
  const [totalvalorobjeto, settotalvalorobjeto] = useState(0);
  const [qtdetotalbrinde, setqtdetotalbrinde] = useState(0);
  const [totalvalorbrinde, settotalvalorbrinde] = useState(0);

  const [showformHistDet, setshowformHistDet] = useState(false);
  const [codContasReceber, setCodContasReceber] = useState(0);

  //campos Historico Detalhado
  const [listaHistoricoDet, setListaHistoricoDet] = useState([]);
  const [isOpenHist, setIsOpenHist] = useState(false);

  //Tela Valor da Venda
  const [showformValorVenda, setshowformValorVenda] = useState(false);
  const [edtNome, setEdtNome] = useState("");
  const [edtValorVendido, setEdtValorVendido] = useState(0);
  const [edtPercComissao, setEdtPercComissao] = useState(0);
  const [edtValorEmpresa, setEdtValorEmpresa] = useState(0);
  const [edtValorBrinde, setEdtValorBrinde] = useState(0);
  const [edtCodContasReceber, setEdtCodContasReceber] = useState(0);
  const [edtStatus, setEdtStatus] = useState("");
  const [edtValor, setEdtValor] = useState(0);
  const [edtValorRestante, setEdtValorRestante] = useState(0);
  const [edtCodBanco, setEdtCodBanco] = useState(0);
  const [edtCodMoeda, setEdtCodMoeda] = useState(0);
  const [listaBanco, setListaBanco] = useState([]);
  const [listaMoeda, setListaMoeda] = useState([]);
  const [edtDtPagamento, setEdtDtPagamento] = useState("");
  const [pendencia, setPendencia] = useState(false);
  const [edtCodDetalhe, setedtCodDetalhe] = useState(0);

  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      ExcluirDetRepasse();
      setIsOpenMotivoExclusao(false);
      fetchListar();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const { DateTime } = require("luxon");

  const dt = new Date();

  const dt11 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");
  let time =
    dt.getHours().toString().padStart(2, "0") +
    ":" +
    dt.getMinutes().toString().padStart(2, "0");
  let dtcadastro = dt11 + " " + time;

  const date1 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const date2 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const [dt1, setdt1] = useState(date1);
  const [dt2, setdt2] = useState(date2);

  const imprimir = async () => {
    setLoading(true);

    try {
      const response = await api.get(`v1/impressoes/relvendaporequipe`, {
        responseType: "arraybuffer",
        params: {
          busca: abusca,
          valor,
          codequipe: edtcodequipe,
          cidade: edtcidade,
          uf: edtuf,
          bairro: edtbairro,
          tipopano: tipoPano1,
          tipocliente: tipoCliente,
          status,
          ativo,
          dt1,
          dt2,
          ordenacao: localStorage.getItem("tempOrdenacao") === "true" ? "T" : "F",
          usuario: localStorage.getItem("tempUsuario"),
          qtdevenda: qtdevendas,
          valorpano: totalvalorpano,
          valorvendido: totalvalorvendido,
          valorempresa: totalvalorempresa,
          qtdepago: qtdetotalpago,
          valorpago: totalvalorpago,
          qtdeaberto: qtdetotalaberto,
          valoraberto: totalvaloraberto,
          qtdenaovisto: qtdetotalnaovisto,
          valornaovisto: totalvalornaovisto,
          qtdedevolvido: qtdetotaldevolvido,
          valordevolvido: totalvalordevolvido,
          codusuario: localStorage.getItem("tempCodUsuario"),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.click();
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  };

  const fetchListar = async () => {
    setLoading(true);

    try {
      const response = await api.get(`${API_URL}/vendaporequipe`, {
        params: {
          busca: abusca,
          valor,
          codequipe: edtcodequipe,
          cidade: edtcidade,
          uf: edtuf,
          bairro: edtbairro,
          tipopano: tipoPano1,
          tipocliente: tipoCliente,
          status,
          ativo,
          offset,
          dt1,
          dt2,
          ordenacao: localStorage.getItem("tempOrdenacao") === "true" ? "T" : "F"
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });
      setqtdevendas(response.data.totais.qtdevendas);
      settotalvalorpano(response.data.totais.totalvalorpano);
      settotalvalorvendido(response.data.totais.totalvalorvendido);
      settotalvalorempresa(response.data.totais.totalvalorempresa);
      setqtdetotalpago(response.data.totais.qtdetotalpago);
      settotalvalorpago(response.data.totais.totalvalorpago);
      setqtdetotalaberto(response.data.totais.qtdetotalaberto);
      settotalvaloraberto(response.data.totais.totalvaloraberto);
      setqtdetotalnaovisto(response.data.totais.qtdetotalnaovisto);
      settotalvalornaovisto(response.data.totais.totalvalornaovisto);
      setqtdetotaldevolvido(response.data.totais.qtdetotaldevolvido);
      settotalvalordevolvido(response.data.totais.totalvalordevolvido);
      setqtdetotalporconta(response.data.totais.qtdetotalporconta);
      settotalvalorporconta(response.data.totais.totalvalorporconta);
      setqtdetotalobjeto(response.data.totais.qtdetotalobjeto);
      settotalvalorobjeto(response.data.totais.totalvalorobjeto);
      setqtdetotalbrinde(response.data.totais.qtdetotalbrinde);
      settotalvalorbrinde(response.data.totais.totalvalorbrinde);

      setlista(response.data.lista);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchListar();
  }, [abusca, valor, offset, edtcodequipe, edtcidade, edtbairro, tipoPano1, tipoCliente, status, ativo, dt1, dt2]);

  const fetchListarPaginas = async () => {
    try {
      const response = await api.get(`${API_URL}/vendaporequipe/pagtotal7`, {
        params: {
          busca: abusca,
          valor,
          codequipe: edtcodequipe,
          cidade: edtcidade,
          uf: edtuf,
          bairro: edtbairro,
          tipopano: tipoPano1,
          tipocliente: tipoCliente,
          status,
          ativo,
          dt1,
          dt2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setqtdetotalpag(response.data.paginatotal);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    }
  };

  useEffect(() => {
    fetchListarPaginas();
  }, [lista]);

  function FormataData(props) {
    return props
      ? DateTime.fromISO(props).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : null;
  }

  function closeModalHistoricoDet() {
    setshowformHistDet(false);
  }

  function openModalEditarDet(item) {
    api
      .get("/v1/operacoes/repasseum1", {
        params: {
          coddetalhe: item.coddetalhe,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setshowformValorVenda(true);
        setEdtNome(response.data.nome);
        setEdtValorVendido(response.data.valorvendido);
        setEdtPercComissao(response.data.perccomissao);
        setEdtValorEmpresa(response.data.valorempresa);
        setEdtValorEmpresa(response.data.valorbrinde);
        setEdtCodContasReceber(response.data.codcontasreceber);
        setEdtStatus(response.data.status);
        setEdtValorRestante(0);
        setEdtCodBanco(response.data.codbanco);
        setEdtCodMoeda(response.data.codmoeda);

        if (response.data.dtbaixa == null) {
          setEdtDtPagamento("");
        } else {
          const dt = new Date(response.data.dtbaixa);
          const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
          let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0");
          let dtcadastro = date + "T" + time;

          setEdtDtPagamento(dtcadastro);
        }

        setPendencia(false);
        setEdtValor(response.data.valor);
        setedtCodDetalhe(response.data.coddetalhe);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function closeModalDet() {
    setshowformValorVenda(false);
  }

  function Recebimento() {
    api
      .post(
        "v1/operacoes/repasse",
        {
          coddetalhe: edtCodDetalhe,
          codcontasreceber: edtCodContasReceber,
          dtlancamento: dtcadastro,
          dtbaixa: edtDtPagamento,
          valorvendido: edtValorVendido,
          perccomissao: edtPercComissao,
          valorempresa: edtValorEmpresa,
          valorbrinde: edtValorBrinde,
          valor: edtValor,
          valorrestante: edtValorRestante,
          codbanco: edtCodBanco,
          codmoeda: edtCodMoeda,
          status: edtStatus,
          excluido: "N",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setshowformValorVenda(false);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function InformarRecebimento() {
    if (edtCodContasReceber === 0) {
      alert("Volte e selecione o repasse");
    } else if (edtStatus === "P") {
      if (pendencia === false) {
        if (edtValorEmpresa === 0) {
          alert("Informe o Valor da Empresa");
        } else if (edtValor === 0) {
          alert("Informe o valor");
        } else if (edtCodBanco === 0) {
          alert("Informe o Caixa/Banco");
        } else if (edtCodMoeda === 0) {
          alert("Informe a Condição de Pagamento");
        } else if (edtDtPagamento === "") {
          alert("Informe a Data de Pagamento");
        } else {
          Recebimento();
        }
      } else {
        if (edtCodBanco === 0) {
          alert("Informe o Caixa/Banco");
        } else if (edtValor === 0) {
          alert("Informe o valor");
        } else if (edtCodMoeda === 0) {
          alert("Informe a Condição de Pagamento");
        } else if (edtDtPagamento === "") {
          alert("Informe a Data de Pagamento");
        } else {
          Recebimento();
        }
      }
    } else if (edtStatus === "A") {
      if (edtValorEmpresa === 0) {
        alert("Informe o Valor da Empresa");
      } else {
        Recebimento();
      }
    } else if (edtStatus === "N") {
      if (edtValorEmpresa === 0) {
        alert("Informe o Valor da Empresa");
      } else {
        Recebimento();
      }
    } else if (edtStatus === "D") {
      if (edtValorEmpresa > 0) {
        alert("Não é para informar o valor");
      } else {
        Recebimento();
      }
    } else {
      Recebimento();
    }
  }

  function openModalHistoricoDet(item) {
    api
      .get("/v1/cadastro/cliente/historicodet", {
        params: {
          codcontasreceber: item.codcontasreceber,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setListaHistoricoDet(response.data);
        setshowformHistDet(true);
        setCodContasReceber(item.codcontasreceber);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarMoeda() {
    api
      .get("v1/cadastro/moeda", {
        params: {
          busca: "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setListaMoeda(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarMoeda();
  }, [showformValorVenda]);

  function ListarBanco() {
    api
      .get("v1/cadastro/banco", {
        params: {
          busca: "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setListaBanco(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarBanco();
  }, [showformValorVenda]);

  const handleOpenHistorico = (cad) => {
    setedtCodDetalhe(cad.coddetalhe);
    setIsOpenHist(true);
  };

  const handleHistClose = () => {
    setIsOpenHist(false);
  };

  const handleHistConfirma = () => {
    setIsOpenHist(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  function ExcluirDetRepasse() {
    api
      .delete("v1/operacoes/excluirdetrepasse", {
        params: {
          coddetalhe: edtCodDetalhe,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        listaHistoricoDet();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  const handleInputChangeEquipe = async (e) => {
    const value = e.target.value;
    setInputValue2(value);

    if (value.length > 2) {
      setLoading(true);
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/equipe`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistaequipe(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      } finally {
        setLoading(false);
      }
    } else {
      setlistaequipe([]);
      setedtcodequipe(0);
    }
  };

  const handleInputChangeCidade = async (e) => {
    const value = e.target.value;
    setInputValue3(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/cidade`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistacidade(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistacidade([]);
      setedtcidade("0");
      setedtuf("");
    }
  };

  const handleInputChangeBairro = async (e) => {
    const value = e.target.value;
    setInputValue4(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/bairro`, {
          params: { busca: value, cidade: edtcidade, uf: edtuf },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistabairro(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistabairro([]);
      setedtbairro("");
    }
  };

  const handleEquipeSelecionado = (equip) => {
    setInputValue2(equip.descricao);
    setedtcodequipe(equip.codequipe);
    setOffset(0);
    setlistaequipe([]);
  };

  const handleCidadeSelecionado = (cid) => {
    setInputValue3(cid.cidade + " - " + cid.uf);
    setedtcidade(cid.cidade);
    setedtuf(cid.uf);
    setOffset(0);
    setlistacidade([]);
  };

  const handleBairroSelecionado = (bai) => {
    setInputValue4(bai);
    setedtbairro(bai);
    setOffset(0);
    setlistabairro([]);
  };

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <h1 className="ms-4">Relatório Vendas Por Equipe</h1>
          <p className="ms-4">
            Rotina para listar todas as vendas por equipe e apresentar um
            resumo.
          </p>
          <hr />
        </div>

        <div>
          <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
            <h2>Antes de Excluir</h2>
            <p>Informe qual o motivo da exclusão?</p>

            <div className="col-sm-12">
              <label htmlFor="motivo" className="form-label">
                Motivo
              </label>
              <input
                type="text"
                id="motivo"
                className="form-control"
                placeholder="Descreva aqui"
                value={edtMotivo}
                onChange={(e) => setEdtMotivo(e.target.value)}
              />
            </div>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button
                  className="btn btn-primary me-2"
                  onClick={handleInformarMotivoExclusao}
                >
                  Informar
                </button>
                <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                  Cancelar
                </button>
              </div>
            </div>
          </PopUpMotivoExclusao>
        </div>

        <PopUpHis isOpen={isOpenHist} onClose={handleHistClose}>
          <h2>Verificação</h2>
          <p>Tem certeza que deseja excluir esse registro?</p>

          <div className="row">
            <div className="col-12 mt-3 d-flex justify-content-end">
              <button
                className="btn btn-primary me-2"
                onClick={handleHistConfirma}
              >
                Sim
              </button>
              <button className="btn btn-danger" onClick={handleHistClose}>
                Não
              </button>
            </div>
          </div>
        </PopUpHis>

        <ModalCobranca
          isOpen={showformHistDet}
          onRequestClose={closeModalHistoricoDet}
          overlayClassName="modal-overlay"
          className="modal-content modal-xl"
          contentLabel="Modal 1"
        >
          <div className="container-fluid h-100">
            <div className="row">
              <h2>
                Histórico Detalhado do Cliente: {edtNome} - Título:{" "}
                {codContasReceber}
              </h2>
            </div>
            <div className="row">
              <hr />
            </div>

            <div className="row tabela">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Lançamento</th>
                    <th>Baixa</th>
                    <th>Valor</th>
                    <th>Banco</th>
                    <th>Moeda</th>
                    <th>Status</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {listaHistoricoDet.map(function (item) {
                    return (
                      <tr key={item.coddetalhe}>
                        <th>{item.coddetalhe}</th>
                        <th>{FormataData(item.dtlancamento)}</th>
                        <th>{FormataData(item.dtbaixa)}</th>
                        <th>
                          {parseFloat(item.valor).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </th>
                        <th>{item.banco}</th>
                        <th>{item.moeda}</th>
                        <th>{item.status}</th>
                        <th>
                          <div className="d-flex justify-content-center">
                            <button
                              className="btn fa-regular fa-pen-to-square"
                              onClick={() => openModalEditarDet(item)}
                            ></button>
                            <button
                              className="btn fa-solid fa-trash"
                              type="button"
                              onClick={() => handleOpenHistorico(item)}
                            ></button>
                          </div>
                        </th>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr>
                    <th colSpan={5}>
                      Quantidade de Registros: {listaHistoricoDet.length}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button
                  className="btn btn-danger ms-4"
                  onClick={closeModalHistoricoDet}
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </ModalCobranca>

        <ModalValorVendido
          isOpen={showformValorVenda}
          onRequestClose={closeModalDet}
          overlayClassName="modal-overlay"
          className="modal-content modal-xl"
        >
          <div className="row">
            <h2>Informe o Valor da Venda de: {edtNome}</h2>
          </div>
          <div className="row">
            <hr />
          </div>

          <div className="row">
            <form>
              <div className="row">
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <label htmlFor="valorvendido" className="form-label">
                    Valor Vendido
                  </label>
                  <input
                    type="number"
                    id="valorvendido"
                    className="form-control"
                    value={edtValorVendido}
                    onChange={(e) => {
                      setEdtValorVendido(e.target.valueAsNumber);
                      setEdtValorEmpresa(e.target.valueAsNumber);
                    }}
                  />
                </div>

                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <label htmlFor="comissao" className="form-label">
                    Perc. Comissão
                  </label>
                  <input
                    type="number"
                    id="comissao"
                    className="form-control"
                    value={edtPercComissao}
                    onChange={(e) => {
                      const newPercComissao = e.target.value;
                      setEdtPercComissao(newPercComissao);
                      setEdtValorEmpresa(
                        Math.round(
                          edtValorVendido -
                          edtValorVendido * (newPercComissao / 100)
                        )
                      );
                      setEdtValor(
                        Math.round(
                          edtValorVendido -
                          edtValorVendido * (newPercComissao / 100)
                        )
                      );
                    }}
                  />
                </div>

                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <label htmlFor="valorempresa" className="form-label">
                    Valor Empresa
                  </label>
                  <input
                    type="number"
                    id="valorempresa"
                    className="form-control"
                    value={edtValorEmpresa}
                    onChange={(e) => setEdtValorEmpresa(e.target.valueAsNumber)}
                    disabled
                  />
                </div>

                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <label htmlFor="valorbrinde" className="form-label">
                    Valor Brinde
                  </label>
                  <input
                    type="number"
                    id="valorbrinde"
                    className="form-control"
                    value={edtValorBrinde}
                    onChange={(e) => {
                      setEdtValorBrinde(e.target.valueAsNumber);
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <p />
                <hr />
              </div>

              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div>
                    <label className="form-label">Status</label>
                    <br />
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="status"
                        value="P"
                        onChange={(e) => setEdtStatus(e.target.value)}
                        checked={edtStatus === "P"}
                      />
                      <label className="form-check-label">Pago</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ativo"
                        value="A"
                        onChange={(e) => setEdtStatus(e.target.value)}
                        checked={edtStatus === "A"}
                      />
                      <label className="form-check-label">Aberto</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ativo"
                        value="N"
                        onChange={(e) => setEdtStatus(e.target.value)}
                        checked={edtStatus === "N"}
                      />
                      <label className="form-check-label">Não Visto</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ativo"
                        value="D"
                        onChange={(e) => setEdtStatus(e.target.value)}
                        checked={edtStatus === "D"}
                      />
                      <label className="form-check-label">Devolvido</label>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="valor" className="form-label">
                    Valor
                  </label>
                  <input
                    type="number"
                    id="valor"
                    className="form-control"
                    value={edtValor}
                    onChange={(e) => {
                      const newValorRestante = e.target.valueAsNumber;
                      setEdtValor(newValorRestante);
                      setEdtValorRestante(edtValorEmpresa - newValorRestante);
                    }}
                  />
                </div>

                <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="valorrestante" className="form-label">
                    Valor Restante
                  </label>
                  <input
                    type="number"
                    id="valorrestante"
                    className="form-control"
                    value={edtValorRestante}
                    disabled
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="banco" className="form-label">
                    Localize o Banco/Caixa
                  </label>
                  <select
                    id="banco"
                    className="form-select"
                    value={edtCodBanco}
                    onChange={(e) => setEdtCodBanco(e.target.value)}
                    disabled={edtStatus !== "P"}
                  >
                    <option value="0">Escolha o banco/caixa</option>
                    {listaBanco.map(function (ban) {
                      return (
                        <option key={ban.codbanco} value={ban.codbanco}>
                          {ban.banco}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="moeda" className="form-label">
                    Localize a Condição de Pagamento
                  </label>
                  <select
                    id="moeda"
                    className="form-select"
                    value={edtCodMoeda}
                    onChange={(e) => setEdtCodMoeda(e.target.value)}
                    disabled={edtStatus !== "P"}
                  >
                    <option value="0">Escolha a condição de pagamento</option>
                    {listaMoeda.map(function (moe) {
                      return (
                        <option key={moe.codmoeda} value={moe.codmoeda}>
                          {moe.moeda}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                  <label htmlFor="dtpagamento" className="form-label">
                    Dt. Pagamento
                  </label>
                  <input
                    type="datetime-local"
                    id="dtpagamento"
                    className="form-control"
                    placeholder="dtcadastro"
                    value={edtDtPagamento}
                    onChange={(e) => setEdtDtPagamento(e.target.value)}
                    disabled={edtStatus !== "P"}
                  />
                </div>
              </div>
            </form>
          </div>

          <div className="row">
            <div className="col-12 mt-3 d-flex justify-content-end">
              <button className="btn btn-danger ms-4" onClick={closeModalDet}>
                Fechar
              </button>
              <button
                className="btn btn-success ms-4"
                onClick={InformarRecebimento}
              >
                Salvar
              </button>
            </div>
          </div>
        </ModalValorVendido>

        <div className="row">
          <div className="col-xl-8 col-lg-6 col-md-6 col-sm-12">
            <label className="form-label" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código, nome ou cpf"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => {
                setabusca(e.target.value);
                setOffset(0);
              }}
            />
          </div>

          <div className="col-xl-2 col-lg-3 col-md-3 col-sm-12">
            <label htmlFor="periodo" className="form-label">
              de...
            </label>
            <br />
            <input
              type="date"
              id="periodo"
              className="form-control"
              placeholder="Data Inicio"
              value={dt1}
              onChange={(e) => setdt1(e.target.value)}
            />
          </div>

          <div className="col-xl-2 col-lg-3 col-md-3 col-sm-12">
            <label htmlFor="periodo" className="form-label">
              Para...
            </label>
            <br />
            <input
              type="date"
              id="periodo2"
              className="form-control"
              placeholder="dtnascimento"
              value={dt2}
              onChange={(e) => setdt2(e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Tipo de Pano</label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="T"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "T"}
              />
              <label className="form-check-label">Todos</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="S"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "S"}
              />
              <label className="form-check-label">Simples</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="E"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "E"}
              />
              <label className="form-check-label">Especial</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="O"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "O"}
              />
              <label className="form-check-label">Ouro</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="P"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "P"}
              />
              <label className="form-check-label">Prata</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="B"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "B"}
              />
              <label className="form-check-label">Bronze</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="M"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "M"}
              />
              <label className="form-check-label">Maleta</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipopano"
                value="L"
                onChange={(e) => setTipoPano1(e.target.value)}
                checked={tipoPano1 === "L"}
              />
              <label className="form-check-label">Platinado</label>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Tipo</label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipocliente"
                value="T"
                onChange={(e) => setTipoCliente(e.target.value)}
                checked={tipoCliente === "T"}
              />
              <label className="form-check-label">Todos</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipocliente"
                value="N"
                onChange={(e) => setTipoCliente(e.target.value)}
                checked={tipoCliente === "N"}
              />
              <label className="form-check-label">Cliente Novo</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipocliente"
                value="R"
                onChange={(e) => setTipoCliente(e.target.value)}
                checked={tipoCliente === "R"}
              />
              <label className="form-check-label">Reposição</label>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Status</label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                value="T"
                onChange={(e) => setStatus(e.target.value)}
                checked={status === "T"}
              />
              <label className="form-check-label">Todos</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                value="P"
                onChange={(e) => setStatus(e.target.value)}
                checked={status === "P"}
              />
              <label className="form-check-label">Pagos</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                value="A"
                onChange={(e) => setStatus(e.target.value)}
                checked={status === "A"}
              />
              <label className="form-check-label">Em Aberto</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                value="N"
                onChange={(e) => setStatus(e.target.value)}
                checked={status === "N"}
              />
              <label className="form-check-label">Não Visto</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                value="D"
                onChange={(e) => setStatus(e.target.value)}
                checked={status === "D"}
              />
              <label className="form-check-label">Devolvido</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                value="O"
                onChange={(e) => setStatus(e.target.value)}
                checked={status === "O"}
              />
              <label className="form-check-label">Objeto</label>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <label htmlFor="equipe" className="form-label">
              Equipe
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue2}
              onChange={handleInputChangeEquipe}
            />
            <ul className="autocomplete-list">
              {listaequipe.map((equipe) => (
                <li
                  key={equipe.codequipe}
                  onClick={() => handleEquipeSelecionado(equipe)}
                >
                  {equipe.descricao}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <label htmlFor="cidade" className="form-label">
              Cidade
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue3}
              onChange={handleInputChangeCidade}
            />
            <ul className="autocomplete-list">
              {listacidade.map((cid) => (
                <li
                  key={cid.cidade}
                  onClick={() => handleCidadeSelecionado(cid)}
                >
                  {cid.cidade} - {cid.uf}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <label htmlFor="bairro" className="form-label">
              Bairro
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue4}
              onChange={handleInputChangeBairro}
            />
            <ul className="autocomplete-list">
              {listabairro.map((bai, index) => (
                <li
                  key={index}
                  onClick={() => handleBairroSelecionado(bai)}
                >
                  {bai}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-xl-1 col-lg-1 col-md-2 col-sm-4">
            <label className="form-label" htmlFor="valor">
              Valor
            </label>
            <input
              type="number"
              placeholder="0"
              name="valor"
              id="valor"
              className="form-control me-3"
              value={valor}
              onChange={(e) => {
                setValor(e.target.value);
                setOffset(0);
              }}
            />
          </div>

          <div className="col-xl-1 col-lg-3 col-md-2 col-sm-4">
            <label className="form-label">Ativo</label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="ativo"
                value="T"
                onChange={(e) => setAtivo(e.target.value)}
                checked={ativo === "T"}
              />
              <label className="form-check-label">Todos</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="ativo"
                value="S"
                onChange={(e) => setAtivo(e.target.value)}
                checked={ativo === "S"}
              />
              <label className="form-check-label">Ativo</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="ativo"
                value="N"
                onChange={(e) => setAtivo(e.target.value)}
                checked={ativo === "N"}
              />
              <label className="form-check-label">Inativo</label>
            </div>
          </div>

          <div className="col-xl-1 col-lg-6 col-md-2 col-sm-4 d-flex justify-content-center">
            <button className="btn" onClick={imprimir} disabled={!podeImprimir("/relatorio/vendaporequipe")}>
              <img src={Impressora} alt="Imprimir" />
              <label>Imprimir</label>
            </button>
            {loading && <LoadingScreen />}
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row ms-2 me-2">
          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Qtde de Vendas</div>
            <div className="card-body">
              <h5 className="card-title text-center">{qtdevendas}</h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Total Valor do Pano</div>
            <div className="card-body">
              <h5 className="card-title text-center">
                {parseFloat(totalvalorpano).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Total Valor Vendido</div>
            <div className="card-body">
              <h5 className="card-title text-center">
                {parseFloat(totalvalorvendido).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Total Valor Empresa</div>
            <div className="card-body">
              <h5 className="card-title text-center">
                {parseFloat(totalvalorempresa).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Qtde Pago</div>
            <div className="card-body">
              <h5 className="card-title text-center">{qtdetotalpago}</h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Total Pago</div>
            <div className="card-body">
              <h5 className="card-title text-center">
                {parseFloat(totalvalorpago).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h5>
            </div>
          </div>
        </div>

        <div className="row ms-2 me-2 ">
          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Qtde Aberto</div>
            <div className="card-body">
              <h5 className="card-title text-center">{qtdetotalaberto}</h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Total Aberto</div>
            <div className="card-body">
              <h5 className="card-title text-center">
                {parseFloat(totalvaloraberto).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Qtde Não Visto</div>
            <div className="card-body">
              <h5 className="card-title text-center">{qtdetotalnaovisto}</h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Total Não Visto</div>
            <div className="card-body">
              <h5 className="card-title text-center">
                {parseFloat(totalvalornaovisto).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Qtde Devolvido</div>
            <div className="card-body">
              <h5 className="card-title text-center">{qtdetotaldevolvido}</h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Total Devolvido</div>
            <div className="card-body">
              <h5 className="card-title text-center">
                {parseFloat(totalvalordevolvido).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h5>
            </div>
          </div>
        </div>

        <div className="row ms-2 me-2">
          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Qtde Por conta</div>
            <div className="card-body">
              <h5 className="card-title text-center">{qtdetotalporconta}</h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Total Por Conta</div>
            <div className="card-body">
              <h5 className="card-title text-center">
                {parseFloat(totalvalorporconta).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Qtde Objeto</div>
            <div className="card-body">
              <h5 className="card-title text-center">{qtdetotalobjeto}</h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Total Objeto</div>
            <div className="card-body">
              <h5 className="card-title text-center">
                {parseFloat(totalvalorobjeto).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Qtde Brinde</div>
            <div className="card-body">
              <h5 className="card-title text-center">{qtdetotalbrinde}</h5>
            </div>
          </div>

          <div className="col-2 card text-bg-primary mb-3">
            <div className="card-header text-center">Total Brinde</div>
            <div className="card-body">
              <h5 className="card-title text-center">
                {parseFloat(totalvalorbrinde).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </h5>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="col-sm-12 table table-hover">
            <thead>
              <tr>
                <th>Código</th>
                <th>Vencimento</th>
                <th>Cliente</th>
                <th>Valor do Pano</th>
                <th onClick={() => { ordValorVenda ? setOrdValorVenda(false) : setOrdValorVenda(true); localStorage.setItem("tempOrdenacao", ordValorVenda); fetchListar() }}>Valor Vendido {ordValorVenda ? "▲" : "▼"}</th>
                <th>Valor da Empresa</th>
                <th>Valor de Brinde</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map((item) => (
                <tr key={item.codcontasreceber}>
                  <th>{item.codcontasreceber}</th>
                  <th>{FormataData(item.dtvencimento)}</th>
                  <th>{item.nome}</th>
                  <th>
                    {parseFloat(item.valorpano).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </th>
                  <th>
                    {parseFloat(item.valorvendido).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </th>
                  <th>
                    {parseFloat(item.valorempresa).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </th>
                  <th>
                    {parseFloat(item.valorbrinde).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </th>
                  <th>{item.status}</th>
                  <th>
                    <div className="d-flex justify-content-center">
                      <button
                        className="btn fa-solid fa-list"
                        type="button"
                        onClick={() => openModalHistoricoDet(item)}
                      ></button>
                    </div>
                  </th>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="3">Quantidade de linhas: {lista.length}</td>
                <td colSpan="5">
                  Total:{" "}
                  {lista
                    .reduce(
                      (total, item) => total + parseFloat(item.valorpano),
                      0
                    )
                    .toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row d-flex justify-content-center">
          <Paginacao
            limit={20}
            total={qtdetotalpag}
            offset={offset}
            setOffset={setOffset}
          />
        </div>
      </div>
    </>
  );
};

export default RelVendaPorEquipe;
